<template>
	<div>
		<div class="d-flex">
			<el-select
				v-model="id"
				filterable
				remote
				default-first-option
				size="mini"
				clearable
				:placeholder="params.placeholder?params.placeholder:'请搜索客户'"
				@change="handleChange"
				:remote-method="refreshData"
				:loading="loadings.main"
			>
				<el-option v-for="item in options" :key="item._id" :label="item.name" :value="item._id">
					<span style="float: left">{{ item.name }}</span>
				</el-option>
			</el-select>
			<el-button
				size="mini"
				type="text"
				style="min-width:2em;"
				@click="handleCreate()"
				v-loading="loadings.create"
				v-if="params.allowCreate"
			>+</el-button>
		</div>
		<div
			class="text-muted text-small"
			v-if="params.tipShow && myValue[params.tipShow]"
		>{{params.tipShowName}} : {{myValue[params.tipShow]}}</div>
		<editor
			:show.sync="editorVisible"
			:data-model-name="dataModelName"
			:record-id="editorId"
			:fields="editorFields"
			@change="onCreated"
			v-if="hasLoadData && params.allowCreate"
		></editor>
	</div>
</template>
<script>
import Editor from "@/components/Editor.vue";
import RelateInput from "@/mixins/RelateInput.js";

export default {
	components: {
		Editor
	},
	mixins: [RelateInput],
	data() {
		return {
			loadings: {
				main: false,
				create: false
			},
			dataModelName: "Agent",
			editorId: "",
			editorVisible: false,
			editorFields: [
				{
					name: "name",
					col: 6,
					rules: ["required"]
				},
				{
					name: "phone",
					col: 6,
					rules: ["required"]
				},
				{
					name: "agent_level",
					col: 6
				},
				{
					name: "province",
					col: 6
				},

				{
					name: "street",
					width: "100%",
					row: 3
				},
				{
					name: "intro",
					width: "100%",
					row: 3
				}
			]
		};
	},
	props: {
		params: {
			type: Object,
			default: () => {
				return {
					type: "Agent",
					tipShow: "",
					tipShowName: "",
					allowCreate: true,
					placeholder: ""
				};
			}
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name", "phone"];
			}
		},
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
					_id: "",
					balance: 0
				};
			}
		}
	},
	created() {
		this.dataModel = this.dataModelName;
	},
	methods: {
		handleCreate() {
			this.editorId = "";
			this.editorVisible = true;
		}
	}
};
</script>
